"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsSignupDesignEnabled = void 0;
const SIGNUP_DESIGN_BRAND_IDS = ['11'];
const SIGNUP_DESIGN_PAGES = [/registration/g];
const getIsSignupDesignEnabled = brandId => {
  const isMatchingBrand = SIGNUP_DESIGN_BRAND_IDS.includes(String(brandId));
  const isMatchingPage = SIGNUP_DESIGN_PAGES.some(matcher => window.location.href.match(matcher));
  return isMatchingBrand && isMatchingPage;
};
exports.getIsSignupDesignEnabled = getIsSignupDesignEnabled;